import { COLORS } from '~/src/common/theme';

interface Props {
  className?: string;
  height?: string | number;
  width?: string | number;
}

const backgroundColor = COLORS.NEUTRAL_PLACEHOLDER;
const borderRadius = 4;

export const Skeleton = ({ width = '100%', height = 20, className }: Props) => {
  const style = { backgroundColor, borderRadius, height, width };
  return <div className={className} style={style} />;
};
